/**
 * Check if case-insensitive "new" string exists in another string. Number would return no match.
 * @param {String|Number} string
 * @return {Boolean} Whether there's a match or not
 */
export const matchesNew = (string: number | string): boolean =>
  !!`${string}`.trim().match(/new/i);
